<template>
  <div class="login-page">
    <CameraCapture :res_out="getCamRes"></CameraCapture>
    <QrCode :qr_func="getSerialNumb" :manual="true"></QrCode>
    <nav
      class="navbar navbar-absolute"
      style="background-color: transparent !important"
    >
      <div class="container">
        <div
          class=""
          style="
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
            align-items: center;
          "
        >
          <a
            style="
              color: #ffffff;
              text-transform: capitalize;
              font-size: 20px;
              padding-top: 0.5rem;
              padding-bottom: 0.5rem;
              line-height: 1.625rem;
            "
            >Modern-Expo</a
          >

          <ul class="nav navbar-nav">
            <li class="dropdown dropdown-language nav-item">
              <a
                class="dropdown-toggle d-flex flex-row"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                placeholder="Change language"
              >
                <!-- <i class="nc-icon nc-globe-2"></i> -->

                <div class="flag" style="width: 2rem; max-height: 1.5rem">
                  <img
                    style="height: 1rem; width: 2rem; object-fit: contain"
                    :src="getFlagImage($i18n.locale)"
                  />
                </div>
                <span class="selected-language" style="color: #ffffff">
                  {{ $i18n.tc("lang.title", $i18n.locale) }}</span
                >
              </a>

              <div aria-labelledby="dropdown-flag" class="dropdown-menu">
                <a
                  class="dropdown-item d-flex flex-row justify-content-start"
                  :id="item.lang"
                  v-for="item in listLanguages"
                  :key="item.id"
                  @click="changeLanguage(item.lang)"
                >
                  <div class="flag" style="width: 2rem; max-height: 1.5rem">
                    <img
                      style="height: 1rem; width: 2rem; object-fit: contain"
                      :src="getFlagImage(item.lang)"
                    />
                  </div>
                  <span>{{
                    $i18n.getLocaleMessage(item.lang).lang.title
                  }}</span>
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <!-- End Navbar -->
    <div class="wrapper wrapper-full-page">
      <div class="full-page section-image" filter-color="black">
        <div
          class="full-page-background"
          :style="{
            backgroundImage:
              'url(' + require('./../assets/img/bg/modern.jpg') + ')',
          }"
        />
        <!--   you can change the color of the filter page using: data-color="blue | purple | green | orange | red | rose " -->
        <div class="content">
          <div class="container-fluid">
            <div class="col-lg-6 ml-auto mr-auto">
              <form class="form" method="" action="">
                <div class="card card-login">
                  <div class="card-header">
                    <div class="card-header">
                      <h3 class="header text-center" style="margin-bottom: 0">
                        {{ $t("quality.title") }}
                      </h3>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="col-md-8 offset-md-2">
                      <div class="input-group mb-0">
                        <input
                          type="text"
                          class="form-control"
                          v-model="serial"
                        />
                        <div class="input-group-append">
                          <span
                            class="input-group-text btn-warning hand"
                            style="
                              background-color: #fbc658;
                              color: #ffffff;
                              font-weight: 600;
                              font-size: 0.8571em;
                            "
                            data-toggle="modal"
                            data-target="#modalQR"
                            @click="$store.state.active_qr = true"
                          >
                            &nbsp;&nbsp;&nbsp;QR code&nbsp;
                          </span>
                        </div>
                      </div>
                    </div>

                    <div style="display: flex; justify-content: center">
                      <button
                        type="button"
                        class="btn btn-warning"
                        data-toggle="modal"
                        data-target="#modalCAM"
                        @click="$store.state.active_cam = true"
                      >
                        <i
                          style="color: #ffffff"
                          class="nc-icon nc-camera-compact"
                        ></i>
                        {{ $t("quality.camera") }}
                      </button>
                      <input
                        type="file"
                        name="file"
                        id="file"
                        class="inputfile"
                        multiple="multiple"
                        @change="onUploadImg"
                        :value="inputFileValue"
                      />
                      <label id="file_loader" for="file">
                        <a
                          class="btn btn-warning"
                          style="font-size: 1em; color: white"
                        >
                          <i class="nc-icon nc-image"></i>
                          {{ $t("quality.selectFiles") }}</a
                        >
                      </label>
                      <!--
                          <button type="button" class="btn btn-warning" @click="images = []; images2 = []" v-if="images.length > 0">
                            <i class="nc-icon nc-box"></i> delete images
                          </button>
                        -->
                    </div>
                    <div class="col-md-12">
                      <div
                        style="
                          display: flex;
                          justify-content: center;
                          flex-wrap: wrap;
                          gap: 10px;
                          align-items: center;
                        "
                      >
                        <div
                          style="
                            min-width: 5%;
                            max-width: 15%;
                            position: relative;
                            cursor: pointer;
                          "
                          v-for="(image, index) in images"
                          :key="index"
                          @click="deleteItem(index)"
                        >
                          <img v-bind:src="image.data" style="width: 100%" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer" v-if="showBtnSend">
                    <a
                      class="btn btn-warning btn-block mb-3"
                      @click="sendFiles"
                      style="color: white"
                    >
                      <h4 style="margin: 0">
                        <i class="nc-icon nc-cloud-upload-94"></i>
                        {{ $t("quality.send") }}
                      </h4>
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <footer class="footer footer-black footer-white">
          <div class="container-fluid">
            <div class="row">
              <div class="credits ml-auto">
                <span class="copyright">
                  © made with <i class="fa fa-heart heart"></i> by Modern-Expo
                  IT TEAM
                </span>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>

    <div v-show="$store.state.isLoading">
      <div
        class="loader-overlay"
        id="point-loader"
        style="position: fixed !important"
      >
        <div
          style="
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <atom-spinner
            :animation-duration="1000"
            :size="160"
            :color="'#ff1d5e'"
          />
        </div>
      </div>
    </div>
    <notifications group="error" classes="alert alert-danger" />
    <notifications group="info" classes="alert alert-info" />
    <notifications group="success" classes="alert alert-success" />
  </div>
</template>

<script>
import CameraCapture from "../components/Camera.vue";
import { AtomSpinner } from "epic-spinners";
import QrCode from "../components/QrCode.vue";

export default {
  name: "Problem",
  data() {
    return {
      inputFileValue: null,
      errors: [],
      serial: null,
      images: [],
      images2: [],

      filesLimit: 25,
      upMBlimit: 200, //MB

      stepFile: 5,

      showBtnSend: false,
    };
  },
  methods: {
    onUploadImg(e) {
      this.inputFileValue = null;

      if (!this.isValid(this.serial)) {
        this.$notify({
          group: "error",
          title: "Warning",
          text: this.$t("quality.enterSerial"),
        });
        this.$store.state.isLoading = false;
      } else {
        let tt = null;
        let name = null;
        let summarySize = 0;
        if (e.target.files.length > 0) {
          let countFiles = e.target.files.length;

          for (let i = 0; i < e.target.files.length; i++) {
            let filesize = 0;
            const element = e.target.files[i];

            filesize = parseFloat(
              (e.target.files.item(i).size / 1024 / 1024).toFixed(3)
            );
            name = element.name;

            const reader = new FileReader();
            reader.readAsDataURL(element);
            reader.onload = (e) => {
              if (
                this.images.length < this.filesLimit &&
                summarySize + filesize < this.upMBlimit
              ) {
                summarySize = summarySize + filesize;
                const filetype = name.split(".").pop().toLowerCase();
                if ("jpg png bmp jpeg".indexOf(filetype) > -1) {
                  let img = new Image();
                  img.onload = () => {
                    const w = img.width;
                    const h = img.height;

                    const canvas = document.createElement("canvas");
                    const ctx = canvas.getContext("2d");

                    canvas.width = w;
                    canvas.height = h;
                    ctx.drawImage(img, 0, 0, w, h);

                    const margin = Math.round(w * 0.02);
                    const fontSize = Math.round(w * 0.03);

                    const now = new Date();
                    const pad = (n) => n.toString().padStart(2, "0");
                    const dateText = `${pad(now.getDate())}.${pad(
                      now.getMonth() + 1
                    )}.${now.getFullYear()} ${pad(now.getHours())}:${pad(
                      now.getMinutes()
                    )}`;

                    ctx.font = `${fontSize}px Arial`;
                    ctx.textBaseline = "bottom";
                    ctx.textAlign = "right";
                    ctx.lineWidth = Math.max(2, fontSize * 0.15);
                    ctx.strokeStyle = "rgba(0,0,0,0.6)";
                    ctx.fillStyle = "white";

                    ctx.strokeText(dateText, w - margin, h - margin);
                    ctx.fillText(dateText, w - margin, h - margin);

                    let base64Img;
                    if (img.width > 1500) {
                      base64Img = canvas.toDataURL("image/jpeg", 0.6);
                    } else {
                      base64Img = canvas.toDataURL("image/png");
                    }

                    tt = base64Img.split(",");

                    this.images.push({
                      name: `${this.serial}_${Math.random(100)}.png`,
                      data: `${tt[0]},${tt[1]}`,
                    });
                    this.images2.push({
                      name: `${this.serial}_${Math.random(100)}.png`,
                      data: tt[1],
                    });

                    console.log(countFiles, this.images.length);
                    this.$store.state.isLoading = false;
                    this.showBtnSend = true;
                  };
                  this.$store.state.isLoading = true;
                  img.src = e.target.result;
                } else {
                  tt = e.target.result.split(",");
                  this.images.push({
                    name: this.serial + "_" + name,
                    data: tt[0] + "," + tt[1],
                  });
                  this.images2.push({
                    name: this.serial + "_" + name,
                    data: tt[1],
                  });
                  this.showBtnSend = true;
                }
              } else {
                this.$notify({
                  group: "info",
                  title: "Warning",
                  text: this.$t("quality.limitSize", {
                    limiCount: this.filesLimit,
                    limitSize: this.upMBlimit,
                  }),
                });
                this.$store.state.isLoading = false;
                return;
              }
            };
          }
        }
      }
    },
    sendFiles(e) {
      e.preventDefault();

      let errors = [];
      let ssParent = this;
      let dataRequest = { images: [], images2: [], serial: null };

      if (this.images.length < 1) {
        errors.push("Прикріпіть фото");
        this.showBtnSend = false;
      }
      if (!this.isValid(this.serial)) {
        errors.push("Відсутній серійний номер");
      }

      if (errors.length == 0) {
        this.serial = "ме-" + this.serial.split("-")[1];
        dataRequest.serial = this.serial;

        //------------------------------------------------------------------------------------------------------

        for (let i = 0; i < this.images.length; i++) {
          if (dataRequest.images.length < this.stepFile) {
            dataRequest.images.push(this.images[i]);
            dataRequest.images2.push(this.images2[i]);
          } else {
            break;
          }
        }
        this.showBtnSend = false;
        getOne(); //first run

        function getOne() {
          ssParent
            .makeQuery("/draw/addimageserialnumber", {
              dataRequest: dataRequest,
            })
            .then((result) => {
              const lenDR = dataRequest.images.length;
              dataRequest.images = [];
              dataRequest.images2 = [];
              ssParent.images = ssParent.images.splice(lenDR);
              ssParent.images2 = ssParent.images2.splice(lenDR);

              console.log(lenDR, ssParent.images.length);

              if (ssParent.images.length > 0) {
                for (let i = 0; i < ssParent.images.length; i++) {
                  if (dataRequest.images.length < ssParent.stepFile) {
                    dataRequest.images.push(ssParent.images[i]);
                    dataRequest.images2.push(ssParent.images2[i]);
                  } else {
                    break;
                  }
                }

                if (dataRequest.images.length > 0) {
                  getOne();
                }
              } else {
                ssParent.showNotification(
                  "success",
                  "Success " + ssParent.serial,
                  "Files uploaded!"
                );
                ssParent.images = [];
                ssParent.images2 = [];
                ssParent.serial = null;
              }
            })
            .catch((error) => {
              ssParent.showBtnSend = true;
              ssParent.showNotification(
                "error",
                ssParent.$t("quality.error"),
                ssParent.$t("quality.tryLater")
              );
              return;
            });
        }
        //------------------------------------------------------------------------------------------------------
      } else if (errors.length != 0) {
        for (let i = 0; i < errors.length; i++) {
          this.$notify({ group: "error", title: "Warning", text: errors[i] });
        }
      }
    },
    getCamRes(dataCam) {
      if (this.images.length < this.filesLimit) {
        if (!this.isValid(this.serial)) {
          this.$notify({
            group: "error",
            title: "Warning",
            text: "Введіть серійний номер",
          });
        } else {
          if (this.isValid(dataCam)) {
            this.images.push({
              name: this.serial + "_" + Math.random(100) + ".png",
              data: dataCam /*.split(',')[1]*/,
            });
            this.images2.push({
              name: this.serial + "_" + Math.random(100) + ".png",
              data: dataCam.split(",")[1],
            });
          }
        }
        this.showBtnSend = true;
      } else {
        this.$notify({
          group: "info",
          title: "Warning",
          text: "Ліміт файлів " + this.filesLimit,
        });
        this.showBtnSend = true;
      }
    },
    deleteItem(index) {
      //remove item
      this.images.splice(index, 1);
      this.images2.splice(index, 1);
    },
    getSerialNumb(serial) {
      if (this.isValid(serial)) {
        this.serial = serial;
        this.serial = "ме-" + this.serial.split("-")[1];
      } else {
        this.$notify({
          group: "error",
          title: "Warning",
          text: "Serial number can not be empty!",
        });
      }
    },
    changeLanguage(len) {
      this.$i18n.locale = len;
    },
    getFlagImage(lang) {
      // Adjust the path according to your project's folder structure
      const images = require.context("../assets/img/flags", false, /\.png$/);
      try {
        return images(`./${this.$i18n.getLocaleMessage(lang).lang.logo}.png`);
      } catch (e) {
        console.error("Image not found:", lang, e);
        return ""; // Fallback or placeholder image
      }
    },
  },
  computed: {
    listLanguages() {
      let arrLang = [];
      for (let i = 0; i < this.$i18n.availableLocales.length; i++) {
        arrLang.push({
          id: this.$i18n.getLocaleMessage(this.$i18n.availableLocales[i]).lang
            .id,
          lang: this.$i18n.availableLocales[i],
        });
      }
      arrLang.sort(function (obj1, obj2) {
        return obj1.id - obj2.id;
      });
      return arrLang;
    },
  },
  components: {
    CameraCapture,
    AtomSpinner,
    QrCode,
  },
  created() {},
  beforeDestroy() {
    this.$root.$off();
  },
  mounted() {
    console.log(this.$router.params);
    if (
      this.$route.params.serial != null ||
      this.$route.params.serial != undefined
    ) {
      let ser = this.$route.params.serial;
      if (ser.indexOf("se-") < 0) {
        ser = "ме-" + ser.split("-")[1];
      }
      this.serial = ser;
    }
  },
  created() {
    //this.$router.push({ name: 'login'});
  },
};
</script>

<style scoped>
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
#file_loader {
  margin: 0px 0px 0px 1%;
  padding: 0px 0px 0px 0px;
  cursor: pointer;
}
.hand {
  cursor: pointer;
}
</style> 


// WEBPACK FOOTER //
// src/pages/Quality2.vue